import { useTranslation } from '@pancakeswap/localization'
import { ArrowBackIcon, Button, Heading } from '@pancakeswap/uikit'
import PageHeader from 'components/PageHeader'
import styled from 'styled-components'

const StyledHeading = styled(Heading)`
  font-weight: 700;
  color: white;
  margin-top: 94px;
  font-size: 48px;
  align-items: flex-start;
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
  @media (max-width: 991px) {
    margin-top: 80px;
  }
  @media (max-width: 767px) {
    transform: translateX(0);
    font-size: 36px;
    margin-bottom: 0;
    flex-direction: column;
    gap: 16px;
  }
`

const StyledButton = styled(Button)`
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: var(--Base-Unit-S-12, 12px);
  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));
  background: var(--HighLight, rgba(255, 255, 255, 0.1));
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const StyleDesc = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
  margin-top: 4px;
  line-height: 140%;
`

const Wrap = styled.div``
const Hero = () => {
  const { t } = useTranslation()
  return (
    <PageHeader>
      {/* <Crumbs /> */}
      <StyledHeading as="h1" scale="xxl" color="secondary">
        <StyledButton as="a" href="/prediction">
          <ArrowBackIcon color="white" width="24px" />
        </StyledButton>
        <Wrap>
          {t('Leaderboard')}{' '}
          <StyleDesc>
            <div>Discover the elite ranks of our leaderboard, where greatness is measured and champions emerge.</div>
            Only claimed rounds are counted for winning-related data.
          </StyleDesc>
        </Wrap>
      </StyledHeading>
    </PageHeader>
  )
}

export default Hero
